import SelectRoledash from '../views/clientviews/selectroledash';
import Login from '../views/clientviews/login';
import LandingPage from '../views/landing/landing';
import Signup from '../views/authentification/SignUp';
import Admin from '../views/authentification/admin'; 
import Otp from '../views/authentification/otp'; 
import Sucess from '../views/authentification/sucess'; 
import Subscription from '../views/authentification/subscription'; 
import PlanDetail from '../views/authentification/PlanDetail'; 
import PlanDetailPerso from '../views/authentification/PlanDetailPerso'; 
import ComingSoon from '../views/comingsoon';
import Testpatientinterface from '../views/clientviews/Patientmanagment/bookapttempoluwasheyi';
import PatientLoginPage from '../views/clientviews/patientLogin';
import FirstLoginPasswordChange from '../views/clientviews/staffmanagment/FirstLoginPasswordChange.js'; 
import ForgetPassword from '../views/authentification/forgetpassword.js';


const Clientroutesnodash = [
  { path: '/landingmed', name: 'LandingPage', element: LandingPage, exact: true },
  { path: '/', name: 'ComingSoon', element: ComingSoon},
  { path: '/clientlogin', name: 'clientlogin', element: Login },
  { path: '/patientlogin', name: 'patientlogin', element: PatientLoginPage },
  { path: '/selectroledash', name: 'SelectRoledash', element: SelectRoledash, exact: true },
  { path: '/clientsignup', name: 'Signup', element: Signup },
  { path: '/clientAdmin', name: 'Admin', element: Admin, exact: true },
  { path: '/Otp', name: 'Otp', element: Otp },
  { path: '/Sucess', name: 'Sucess', element: Sucess, exact: true },
  { path: '/Subscription', name: 'Subscription', element: Subscription },
  { path: '/plan/:planId', name: 'PlanDetail', element: PlanDetail, exact: true },
  { path: '/planPersonalized/:planPersoId', name: 'PlanDetail', element: PlanDetailPerso, exact: true },
  { path: '/testpatientinterface', name: 'Testpatientinterface', element: Testpatientinterface, exact: true },
  { path: '/hospitaladmin/firstLoginPasswordChange', name: 'FirstLoginPasswordChange', element: FirstLoginPasswordChange },
  { path: '/reset-password/:token', name: 'Generalcongig', element: ForgetPassword },
  { path: '/forget-password', name: 'Generalcongig', element: ForgetPassword },

]

export default Clientroutesnodash;
